import styles from "./AutomatedEmailsConstants.module.scss";
import { useGetEmailTemplateConstantsQuery } from "../../../api/queries";
import { useTranslation } from "react-i18next";
import MainTitle from "../../../components/ui/MainTitle/MainTitle";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { openSuccessMessage } from "../../../store/message/messageSlice";

const AutomatedEmailsConstants = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { data: constants = [] } = useGetEmailTemplateConstantsQuery();
  if (constants.length === 0) return null;

  const copyToClipboard = (constant: string) => {
    navigator.clipboard
      .writeText(constant)
      .then(() => {
        dispatch(openSuccessMessage(t("CopiedToClipboard")));
      })
      .catch((err) => {
        console.error("Failed to copy!", err);
      });
  };

  return (
    <div className={styles.section}>
      <MainTitle text={t("Constants")} />
      <div className={styles.wrapper}>
        {constants.map((el) => {
          return (
            <div key={el} className={styles.item} onClick={() => copyToClipboard(el)}>
              <h4>{t(el)}</h4>
              <p>{el}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AutomatedEmailsConstants;
